import React, { useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useRadio } from '@react-aria/radio';
import { VisuallyHidden } from '@react-aria/visually-hidden';
import { useFocusRing } from '@react-aria/focus';
import { RadioContext } from '../../../shared/components/AriaRadio/RadioGroup';
import DisabledIcon from '../../../shared/icons/icon-radio-disabled.svg';

const SwatchVariantsRadio = function SwatchVariantsRadioComponent(props) {
  const {
    value,
    children,
    selected,
    disabled,
    blocked,
    buttonImageUrl,
  } = props;

  const state = useContext(RadioContext);
  const ref = useRef(null);

  const { inputProps } = useRadio({
    ['aria-label']: value,
    ...props,
  }, state, ref);
  const { isFocusVisible, focusProps } = useFocusRing();

  const radioClass = classNames('product-details__swatch',
  {
    'product-details__swatch--disabled': disabled,
    'product-details__swatch--selected': selected,
    'product-details__swatch--focused': isFocusVisible,
  });

  return (
    <label
      className={radioClass}
      style={{backgroundImage: `url("${buttonImageUrl}")`}}
    >
      <VisuallyHidden elementType="span">
        <input {...inputProps} {...focusProps} ref={ref} disabled={disabled || blocked} />
      </VisuallyHidden>
      {disabled && <DisabledIcon className="product-details__swatch-disabled-icon" />}
      {children}
    </label>
  );
};

SwatchVariantsRadio.propTypes = {
  value: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  blocked: PropTypes.bool,
  buttonImageUrl: PropTypes.string,
};

SwatchVariantsRadio.defaultProps = {
  disabled: false,
  blocked: false,
};

export default SwatchVariantsRadio;
